<template>
    <div>
        <!-- Tagging-->
          <h4 class="mb-4">Tag</h4>
          <vs-row vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-xs="12"
            >
              <!-- {{tagModuleWise}} -->
              <v-select
                class="w-full"
                label="name"
                taggable
                :reduce="(option) => option.id"
                :create-option="
                  (option) => ({ id: option, label: option, name: option })
                "
                :options="tagModuleWise"
                placeholder="Type and press enter to create a tag and then attach it."
                v-model="tagSelected"
                :clearable="false"
                data-vv-name="tag_list"
                name="tag_list"
                multiple
              >
              
              </v-select>
            </vs-col>

            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="center"
              vs-lg="3"
            >
              <vs-button @click.prevent="checkingTagChanges">Attach Tag</vs-button>
            </vs-col>
          </vs-row>
          <span
            v-show="errors.has('Questions.subject_list')"
            class="text-danger block"
            >{{ errors.first("Questions.subject_list") }}</span
          >
        <!-- Tagging -->

    </div>
</template>

<script>
import vSelect from 'vue-select'
import { Tag } from '@/mixins/tag/tag'

export default {
  name:'TagComponent',
  components:{
    vSelect
  },
  mixins: [Tag],

  props: {
   
  },
  computed: {
   
  },
  created () {
    
    if (this.$route.params.editing_object) {
      
      const editing_type = this.$route.params.editing_type

      let tagsselected = []
      if (editing_type === 'Course') {
        tagsselected = this.$route.params.editing_object.courseTags.map((tag) => {
          return tag.tag.id
        })
      } else if (editing_type === 'lessons') {
        tagsselected = this.$route.params.editing_object.lessonTags.map((tag) => {
          return tag.tag.id
        })
      } else if (editing_type === 'topics') {
        tagsselected = this.$route.params.editing_object.topicTags.map((tag) => {
          return tag.tag.id
        })
      }
      
      this.tagSelected = tagsselected
      
      this.oldtagSelected = tagsselected
    }
  },
  mounted () {
    this.fetchTag(this.platform_module_id)
  },

  data () {
    return {  
      platform_module_id:3
    }

  },
  methods:{
   
  }
    
}
</script>